(function(){
  try{var t=document.createElement('link');
    if(!(t.relList&&t.relList.supports&&t.relList.supports('prefetch')))return;}catch(e){return;}
  var conn=navigator.connection;
  if(conn&&(conn.saveData||(conn.effectiveType||'').indexOf('2g')>-1))return;
  var done=Object.create(null),count=0,MAX=20;
  function eligible(a){
    if(!a||!a.href)return false;
    var u;try{u=new URL(a.href,location.href);}catch(e){return false;}
    if(u.origin!==location.origin)return false;
    if(done[u.href]||u.href===location.href)return false;
    var tg=a.getAttribute('target');if(tg&&tg!=='_self')return false;
    if(a.hasAttribute('download'))return false;
    var p=u.pathname.toLowerCase();
    if(/(^|\/)(cart|checkout|checkouts|account|orders|admin|apps|services|tools|password|logout|\d{7,})(\/|$)/.test(p))return false;
    if(/[?&](add|logout)/.test(u.search))return false;
    if(u.hash&&u.pathname===location.pathname&&u.search===location.search)return false;
    return true;
  }
  function pf(href){if(done[href]||count>=MAX)return;done[href]=1;count++;
    var l=document.createElement('link');l.rel='prefetch';l.href=href;try{l.as='document';}catch(e){}
    document.head.appendChild(l);}
  document.addEventListener('mouseover',function(e){
    var a=e.target.closest?e.target.closest('a'):null;if(!eligible(a))return;
    var href=new URL(a.href,location.href).href;a.__czt=setTimeout(function(){pf(href);},55);
  },{passive:true,capture:true});
  document.addEventListener('mouseout',function(e){
    var a=e.target.closest?e.target.closest('a'):null;if(a&&a.__czt){clearTimeout(a.__czt);a.__czt=null;}
  },{passive:true,capture:true});
  document.addEventListener('touchstart',function(e){
    var a=e.target.closest?e.target.closest('a'):null;if(eligible(a))pf(new URL(a.href,location.href).href);
  },{passive:true,capture:true});
})();